import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogStatusDropdownContentWireframe from '../../VeltCommentDialogStatusDropdownContentWireframe/VeltCommentDialogStatusDropdownContentWireframe';
import VeltCommentDialogStatusDropdownTriggerWireframe from '../../VeltCommentDialogStatusDropdownTriggerWireframe/VeltCommentDialogStatusDropdownTriggerWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
;
var VeltCommentDialogStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatus.Content = VeltCommentDialogStatusDropdownContentWireframe;
VeltCommentDialogStatus.Trigger = VeltCommentDialogStatusDropdownTriggerWireframe;
export default VeltCommentDialogStatus;
